import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const CancellationReasonIcon = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M19.999 2.19922H4.01C2.91 2.19922 2.009 3.09922 2.009 4.19922L2 16.1982C2 17.3032 2.895 18.1992 4 18.1992H5.499C5.775 18.1992 5.999 18.4232 5.999 18.6992V20.7852C5.999 21.6762 7.076 22.1222 7.706 21.4922L10.706 18.4922C10.894 18.3042 11.148 18.1992 11.413 18.1992H19.999C21.099 18.1992 21.999 17.2992 21.999 16.1992V4.19922C21.999 3.09922 21.099 2.19922 19.999 2.19922ZM15.293 12.0782C15.684 12.4692 15.684 13.1022 15.293 13.4922C14.902 13.8832 14.269 13.8832 13.879 13.4922L12 11.6132L10.121 13.4922C9.73 13.8832 9.097 13.8832 8.707 13.4922C8.316 13.1012 8.316 12.4682 8.707 12.0782L10.586 10.1992L8.707 8.32022C8.316 7.92922 8.316 7.29622 8.707 6.90622C9.098 6.51622 9.731 6.51522 10.121 6.90622L12 8.78522L13.879 6.90622C14.27 6.51522 14.903 6.51522 15.293 6.90622C15.683 7.29722 15.684 7.93022 15.293 8.32022L13.414 10.1992L15.293 12.0782Z",
      fill: "currentColor"
    }
  ) }),
  "CancellationReason"
);
export {
  CancellationReasonIcon
};
